export class PasteService {
    getData(event: ClipboardEvent): string {
        const w: any = window;
        const e: any = event;

        // Stop data actually being pasted into div
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }

        // Get pasted data via clipboard API
        const clipboardData = e.originalEvent.clipboardData || w.clipboardData;
        return clipboardData.getData('Text');
    }

    getGridData(event: ClipboardEvent, data: any, year: any, field: any, columnCount: number): any {
        const tempData = data;
        const minRow = Number(tempData[0].year);
        const maxRow = Number(tempData[tempData.length - 1].year);
        const maxCol = columnCount;

        let pastedData = null;
        let tempRow = null;
        let i = null;
        let j = null;
        let yr = null;
        let rw = null;
        let idx = null;
        let val = null;

        // Get pasted data via clipboard API
        pastedData = this.getData(event);

        // This routine is built to deal with Excel data.  The copy string from Excel
        // delimits the values by char(9) on columns and uses hex 021B5 for rows.  There
        // is always a final hex 021B5 at the end of the copy string.
        // Get rid of any formatting characters
        let pastedDataDel = pastedData.replace(/[$,)]/g, '');
        pastedDataDel = pastedDataDel.replace(/[(]/g, '-');

        // Next convert the column separators into a ?
        const pastedDataR = pastedDataDel.replace(/[\x09]/g, '?');

        // Next convert the row separators into !!
        let pastedDataC = pastedDataR.replace(/[^0-9.\-?\%]/g, '!');

        // Allow for copy paste inside of the grid
        if (pastedDataC.indexOf('!!') === -1 && pastedDataC.indexOf('!') !== -1) {
            const pastedDataG = pastedDataC.replace(/[!]/g, '!!');
            pastedDataC = pastedDataG;
        }
        // strip off the final"!!"
        if (pastedDataC.substring(pastedDataC.length - 1, 2) === '!!') {
            pastedDataC = pastedDataC.substring(0, pastedDataC.length - 2);
        }

        // If it is a single row (i.e. no !!), assume it is really a column of data to be entered
        if (pastedDataC.indexOf('!!') === -1) {
            pastedDataC = pastedDataC.replace(/[?]/g, '!!');
        }

        // Split into rows
        const rowArray = pastedDataC.split('!!');

        // Split each row  into an array
        const rowArray2d = new Array();
        for (i = 0; i < rowArray.length; i++) {
            rowArray2d[i] = rowArray[i].split('?');
        }

        rw = year;
        for (j = 0; j < rowArray.length; j++) {
            idx = Number(rw) + j - minRow;
            if (idx > maxRow) {
                break;
            }

            tempRow = tempData[idx];
            yr = field;
            for (i = 0; i < rowArray2d[0].length; i++) {
                val = rowArray2d[j][i];
                // Allow for Excel data to have a trailing % sign
                if (val.charAt(val.length - 1) === '%') {
                    val = Number(val.substring(0, val.length - 1)) / 100;
                }
                tempRow[yr] = Number(val);
                yr++;
                if (yr > maxCol) {
                    break;
                }
            }
        }

        return tempData;
    }
}
